import { request, makePath } from './http';
const API_NAME = 'taxonomy';

export function getTaxonomy(name) {
  return request('GET', makePath(API_NAME), {params: {name}});
}
